<template>
    <div class="partial-footer"></div>
</template>

<script>
  export default{
    name: 'PartialFooter'
  }
</script>


// WEBPACK FOOTER //
// PartialFooter.vue?4088ebf3